var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('img',{staticClass:"img",attrs:{"src":_vm.public_path + '/static/images/publicity.png',"alt":""}}),_vm._v(" "),_c('div',{staticClass:"btn"},[_c('button',{on:{"click":_vm.publicity}},[_vm._v("我要申请")]),_vm._v(" "),_c('button',{staticClass:"sigin-out",on:{"click":_vm.logout}},[_vm._v("我要退出")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f0bd84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/publicity/publicity.vue
// module id = null
// module chunks = 